import { apiGrayCheckUserP } from '@/api/workbench';

const grayPlatformEnvKey = (process.env.VUE_APP_ENV || 'test') as 'test' | 'production';
const GRAY_PLATFORM_URL =
  { test: 'https://iwork.test.mi.com', production: 'https://iwork.mi.com' }[grayPlatformEnvKey] ??
  'https://iwork.mi.com';

/**
 * 入口尽早调用：接口判定为灰度用户则跳转到新平台。
 */
export async function redirectIfGrayUser(userMiId?: string): Promise<void> {
  try {
    const res = await apiGrayCheckUserP({
      projectTag: 'global-retail-pc',
      userMiId
    });
    if (res?.data === true) {
      window.location.href = GRAY_PLATFORM_URL;
    }
  } catch (error) {
    console.error('grayCheckUserP error:', error);
  }
}
